module.exports = __webpack_public_path__ + "img/subs-other.20f4a4d6.png";